import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface CreateUserNoteParams {
	readonly targetId: string;
	readonly note: string;
}

@Injectable({ providedIn: 'root' })
export class CreateUserNoteApiMutation extends ApiMutation<
	string,
	CreateUserNoteParams
> {
	client = 'iam';
	document = gql`
		mutation CreateUserNote(
			$note: String!
			$targetId: UUID!
			$type: UserNoteType
		) {
			createUserNote(note: $note, targetId: $targetId, type: $type)
		}
	`;
	method = 'createUserNote';
}
